import { MainMenuApi as api } from '../api/api.js'
import { enable, disable, setFetchMethod } from 'darkreader'

export default {
  data: () => ({
    itemsMenu: [],
    baseUrl: '',
    listView: undefined,
    selectMenuItem: undefined,
    userSettings: {
      mainColor: '',
      accentColor: '',
      userSizeSettingsString: '',
      defaultSizeSettingsString: ''
    },
    layoutDescription: undefined
  }),
  watch: {
    isUserAuthenticated(val) {
      if (!val) {
        this.$routerCore.RedirectAfterLogin()
      }
    }
  },
  async created() {
    if (!this.isUserAuthenticated) {
      return
    }
    this.isLoading = true
    let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
    if (data) {
      this.setData(data)
    }
    data = await api.getMenu()
    if (!data && !data.data.iTEnterpriseMenuQuery) {
      return
    }

    this.setData(data)
    localStorage.setItem('appMainMenuCacheMenu', JSON.stringify(data))
    this.isLoading = false
  },
  computed: {
    // false - страница загружена во фрейме
    // true - страница загружена в основном окне
    isAppInIFrame() {
      let isFramed
      try {
        isFramed = window != window.top || document != top.document || self.location != top.location
      } catch (e) {
        isFramed = true
      }

      return isFramed
    },
    routeName() {
      return this.$route.name
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated
    },
    loader() {
      return this.$store.getters.getProcessing
    }
  },
  methods: {
    changedCode(item) {
      // если у функции есть ссылка
      if (item.httpLink) {
        window.open(item.httpLink)
        return
      }
      this.selectMenuItem = item
      if (window.parent && window.parent.postMessage && window.parent != window) {
        window.parent.postMessage({ type: 'CallMainMenuFunction', codeMenu: item.codeMenu }, '*')
        return
      }
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      let projectCode = data.data.iTEnterpriseMenuQuery.menu.currentProject
      if (projectCode) {
        let parts = projectCode.split('_')
        if (parts.length > 1 && parts[parts.length - 1].length == 2) {
          parts[parts.length - 1] = localStorage.getItem('language')
        }
        projectCode = parts.join('_')
      }
      window.open(`${this.baseUrl}/?${item.shareParams}&startFromLauncher=true&proj=${projectCode}`, '_self')
    },
    getColorSettingsFromString(colorString) {
      let colorArray = colorString.split('-')
      if (colorArray.length > 1) {
        return {mainColor: colorArray[0], accentColor: colorArray[1]}
      }
    },

    setVisualSettings(currentSettings) {
      if (currentSettings) {
        // персональные настройки пользователя
        if (currentSettings.userRmdSettings) {
          if (currentSettings.userRmdSettings.colorPaletteValue) {
            let colorSettings = this.getColorSettingsFromString(currentSettings.userRmdSettings.colorPaletteValue)
            if (colorSettings) {
              this.userSettings.accentColor = colorSettings.accentColor
              this.userSettings.mainColor = colorSettings.mainColor
            }
          }
          if (currentSettings.userRmdSettings.settingsValue) {
            this.userSettings.userSizeSettingsString = currentSettings.userRmdSettings.settingsValue
          }
        }
        if (currentSettings.defaultRmdSettings) {
          if (currentSettings.defaultRmdSettings.colorPaletteValue) {
            let colordefaultSettings = this.getColorSettingsFromString(currentSettings.userRmdSettings.colorPaletteValue)
            if (colordefaultSettings) {
              this.userSettings.accentColor = this.userSettings.accentColor ?? colordefaultSettings.accentColor
              this.userSettings.mainColor = this.userSettings.mainColor ?? colordefaultSettings.mainColor
            }
            if (currentSettings.defaultRmdSettings.settingsValue) {
              this.userSettings.defaultSizeSettingsString = currentSettings.defaultRmdSettings.settingsValue
            }
          }
        }
        if (currentSettings.darkThemeOn) {
          setFetchMethod(window.fetch)
          enable({ brightness: 100, contrast: 90, sepia: 10 })
        } else {
          disable()
        }
      }
    },
    setData(data) {
      this.itemsMenu = data.data.iTEnterpriseMenuQuery.menu.items
      this.favoriteModule = data.data.iTEnterpriseMenuQuery.menu.moduleContent.children
      this.baseUrl = data.data.iTEnterpriseMenuQuery.menu.baseUrl
      this.isLoading = false
      this.layoutDescription = data.data.iTEnterpriseMenuQuery.layoutDescription
      if (!this.layoutDescription || !this.layoutDescription.length) {
        this.layoutDescription = [ { row: 0, col: 0, sizeY: 24, sizeX: 24, controlId: '0.36024457542999877'} ] 
      }
      this.listView = data.data.iTEnterpriseMenuQuery.listView.items
      this.setVisualSettings(data.data.iTEnterpriseMenuQuery.userSettings)
    }
  }
}
